import { TextComponent, TextComponentProps } from './TextComonent'

export default TextComponent

export { type TextComponentProps, TextComponent }
